import { render, staticRenderFns } from "./Folderproduct.vue?vue&type=template&id=a85000b8"
import script from "./Folderproduct.vue?vue&type=script&lang=js"
export * from "./Folderproduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports